 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"cb1608f2","2":"styles","3":"7e8610091125eec0bcb59d702408cef5910b9c75","4":"0a55b0343f086fa8a10f347a02ae92dc9f88a97e","5":"09db5b2032cef55a42d6882c7f5cbdbedfbe99ac","6":"a9a7754c","7":"cc73f56f783d8e05f7537e3a9b77b0732e880a24","8":"8b1d21c3b138486671fb4c199f7579147694397f","9":"cd0a5a619baf7e2a0077bddda8028119e3340b86","12":"component---src-pages-404-js","13":"component---src-pages-about-js","14":"component---src-pages-blog-js","15":"component---src-pages-cash-reinvesting-js","16":"component---src-pages-cash-reinvesting-qt-js","17":"component---src-pages-features-js","18":"component---src-pages-forever-free-js","19":"component---src-pages-index-js","20":"component---src-pages-joe-hogue-js","21":"component---src-pages-moneygeek-js","22":"component---src-pages-newsletter-js","23":"component---src-pages-portfolio-rebalancing-js","24":"component---src-pages-portfolio-rebalancing-qt-js","25":"component---src-pages-portfolio-tracking-js","26":"component---src-pages-portfolio-tracking-qt-js","27":"component---src-pages-pricing-js","28":"component---src-pages-privacy-js","29":"component---src-pages-questrade-js","30":"component---src-pages-questrade-portfolio-tracker-js","31":"component---src-pages-security-js","32":"component---src-pages-terms-of-service-js","33":"component---src-pages-tutorials-js","34":"component---src-templates-blog-post-js","35":"component---src-templates-landing-new-page-js","36":"component---src-templates-landing-page-js","37":"component---src-templates-moneygeek-js","38":"component---src-templates-tutorial-js"}[chunkId]||chunkId) + "-" + {"0":"d838fdc2eb2c13e009ee","1":"c97d87bc4f8f18afe77c","2":"f3e9059f8c2a75df70f2","3":"62b54d68e8696ffbf4bb","4":"51cf679dd32aef583584","5":"1d482890c67c3ef91017","6":"7acce775ac2e35665fda","7":"007af7f3fb5aee72e95f","8":"530114e30d8dcd7d46b6","9":"043e28c01e83534e549f","12":"0c2afc62593dbaea4cd9","13":"43697c572ccfbc43d930","14":"c72a645e4093b57531e9","15":"c580d3a5c2a72ea8ffd0","16":"650b43c298cb6db635fc","17":"fcd94791b90b9fbba85a","18":"f5537e4787f30ae25006","19":"d8acad7850397ba538d6","20":"5b879018139c039405c5","21":"c466aa76920b3e70230b","22":"522ca174e7d6ed50d0d6","23":"9ead007b1cf0a1eac0e5","24":"1d37b34f0a0c738a3960","25":"7d9679be247daedd3633","26":"987bd6b309496fb07394","27":"cfc3f63f9761ef8b7a08","28":"6efb1c1a75b71ebf0c6c","29":"e61324b66d3d2ec877e7","30":"1e546468f03f4ef0942f","31":"138f9f012bcf3b079c6e","32":"8e186e6311b954a2f595","33":"d25d035596e6f18fd954","34":"03630b7194d506e6ab60","35":"7d7e04ec6807aa018948","36":"36b1ce1416d0875bd315","37":"7eef7657902acd0990b7","38":"40249bd6b9afbfeec622"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"cb1608f2","2":"styles","3":"7e8610091125eec0bcb59d702408cef5910b9c75","4":"0a55b0343f086fa8a10f347a02ae92dc9f88a97e","5":"09db5b2032cef55a42d6882c7f5cbdbedfbe99ac","6":"a9a7754c","7":"cc73f56f783d8e05f7537e3a9b77b0732e880a24","8":"8b1d21c3b138486671fb4c199f7579147694397f","9":"cd0a5a619baf7e2a0077bddda8028119e3340b86","12":"component---src-pages-404-js","13":"component---src-pages-about-js","14":"component---src-pages-blog-js","15":"component---src-pages-cash-reinvesting-js","16":"component---src-pages-cash-reinvesting-qt-js","17":"component---src-pages-features-js","18":"component---src-pages-forever-free-js","19":"component---src-pages-index-js","20":"component---src-pages-joe-hogue-js","21":"component---src-pages-moneygeek-js","22":"component---src-pages-newsletter-js","23":"component---src-pages-portfolio-rebalancing-js","24":"component---src-pages-portfolio-rebalancing-qt-js","25":"component---src-pages-portfolio-tracking-js","26":"component---src-pages-portfolio-tracking-qt-js","27":"component---src-pages-pricing-js","28":"component---src-pages-privacy-js","29":"component---src-pages-questrade-js","30":"component---src-pages-questrade-portfolio-tracker-js","31":"component---src-pages-security-js","32":"component---src-pages-terms-of-service-js","33":"component---src-pages-tutorials-js","34":"component---src-templates-blog-post-js","35":"component---src-templates-landing-new-page-js","36":"component---src-templates-landing-page-js","37":"component---src-templates-moneygeek-js","38":"component---src-templates-tutorial-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"cdcfc71e91a1edfb370e","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
